module.exports = __webpack_public_path__ + "static/media/Recipe.d9973f9f.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/Projects/Recipe.JPG
// module id = 794
// module chunks = 0